import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {User} from '../../../../../models/user';
import {Subscription} from 'rxjs';
import {ValidationInfoService} from '../../../../../repositories/validation-info.service';

@Component({
  standalone: false,
  selector: 'app-purpose-type',
  templateUrl: './purpose-type.component.html',
  styleUrls: ['./purpose-type.component.scss']
})
export class PurposeTypeComponent implements OnInit, OnDestroy {
  public submitted: boolean;
  private subscription: Subscription;

  constructor(private validationService: ValidationInfoService) {
    this.submitted = false;
  }

  private _userModel: User;

  get userModel(): User {
    return this._userModel;
  }

  @Input()
  set userModel(value: User) {
    this._userModel = value;
  }

  ngOnInit() {
    this.subscription = this.validationService.onUserUpdate.subscribe(() => {
      this.submitted = true;

      this.validationService.validate(this.userModel.purposeIndependent || this.userModel.purposeFixed,
        'PurposeTypeComponent');
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
